var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubBagFinalize(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F4F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9017 28.6819C38.4345 24.6788 37.7519 21.6773 37.1189 19.5448C36.5998 17.7963 36.3402 16.922 35.2759 16.1278C34.2117 15.3335 33.1238 15.3335 30.9481 15.3335H23.718C21.5423 15.3335 20.4544 15.3335 19.3901 16.1278C18.3258 16.922 18.0663 17.7963 17.5472 19.5448C16.9142 21.6773 16.2315 24.6788 15.7644 28.6819C15.2138 33.3998 14.9385 35.7587 16.5294 37.546C18.1204 39.3335 20.6986 39.3335 25.8551 39.3335H27.4775",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 20.6665C23.333 22.8756 25.1239 24.6665 27.333 24.6665C29.5422 24.6665 31.333 22.8756 31.333 20.6665",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.333 37.9998C31.333 37.9998 32.6663 37.9998 33.9997 40.6665C33.9997 40.6665 36.9017 33.9998 40.6663 32.6665",
    stroke: "#2B3674",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubBagFinalize);
export default __webpack_public_path__ + "static/media/HubBagFinalize.a66e2d848d24aa1b27cca44a8efc64c1.svg";
export { ForwardRef as ReactComponent };